import { render } from "./BaseLegend.vue?vue&type=template&id=6aabd2c9"
import script from "./BaseLegend.vue?vue&type=script&lang=js"
export * from "./BaseLegend.vue?vue&type=script&lang=js"

import "./BaseLegend.vue?vue&type=style&index=0&id=6aabd2c9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__